/**
 * MapLibre GL and its Leaflet binding, for DarkBasemap.jsx. They're large,
 * so they load when the first map mounts (never in the main bundle) and are
 * shared after that.
 */

let loading = null;

/** The binding's layer factory. A failed load is retried by the next map. */
export function loadMaplibreLeaflet() {
  loading ||= Promise.all([
    import('maplibre-gl'),
    // MapLibre looks for its worker next to its own file, which bundling
    // breaks, so the worker ships as an asset and MapLibre is told its URL.
    import('maplibre-gl/dist/maplibre-gl-worker.mjs?url'),
    import('@maplibre/maplibre-gl-leaflet'),
    import('maplibre-gl/dist/maplibre-gl.css'),
  ])
    .then(([maplibregl, worker, plugin]) => {
      maplibregl.setWorkerUrl(worker.default);
      return plugin.maplibreGL;
    })
    .catch((err) => {
      loading = null;
      throw err;
    });
  return loading;
}

let webgl2 = null;

/** MapLibre 6 draws with WebGL2 only. Probed once; the probe's context is released. */
export function supportsWebGL2() {
  if (webgl2 === null) {
    try {
      const gl = document.createElement('canvas').getContext('webgl2');
      webgl2 = Boolean(gl);
      gl?.getExtension('WEBGL_lose_context')?.loseContext();
    } catch {
      webgl2 = false;
    }
  }
  return webgl2;
}
